import { useEffect, useState, useCallback } from "react";
import { AppShell } from "@/components/shell/AppShell";
import api from "@/lib/api";
import { Loading, fmtNum } from "./axiom";
import { UploadTab } from "./UploadTab";
import { DashboardTab } from "./DashboardTab";
import { DateTab } from "./DateTab";
import { TrendsTab } from "./TrendsTab";
import { AgentsTab } from "./AgentsTab";
import { BenchmarkTab } from "./BenchmarkTab";
import { ExportTab } from "./ExportTab";

const TABS = ["Upload", "Dashboard", "Date Analysis", "Trends", "Agents", "Benchmark", "Export"];

export default function AhtPage() {
  const [summary, setSummary] = useState(null);
  const [tab, setTab] = useState("Upload");
  const [filters, setFilters] = useState({ lob: "", category: "", sub_category: "", sub_sub: "", lang: "", location: "", month_from: "", month_to: "" });

  const refresh = useCallback(() => {
    api.get("/aht/summary").then((r) => {
      setSummary(r.data);
      setTab((t) => (r.data.total > 0 && t === "Upload" ? "Dashboard" : t));
    });
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const hasData = summary?.total > 0;
  const props = { summary: summary || {}, filters, setFilters, refresh };

  return (
    <AppShell wide>
      <div className="mb-5 flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 data-testid="aht-title" className="font-heading text-3xl font-extrabold tracking-tight text-thstrong sm:text-4xl">
            AHT Analytics <span className="ml-1 text-lg font-semibold text-thcyan">Benchmarking Intelligence</span>
          </h1>
          <p className="mk-label mt-2 tracking-[0.25em]">Average handle time · {hasData ? `${fmtNum(summary.total)} benchmark calls loaded` : "no dataset yet"}</p>
        </div>
        <span data-testid="aht-hierarchy-badge" className="hidden rounded-full border border-thmint/30 bg-thmint/10 px-3 py-1.5 text-[11px] font-semibold text-thmint xl:block">
          ✓ 3-Level Hierarchy Active
        </span>
      </div>
      <nav className="mb-6 flex gap-1 overflow-x-auto border-b border-thborder/10" data-testid="aht-tabs">
        {TABS.map((t) => {
          const disabled = t !== "Upload" && !hasData;
          return (
            <button key={t} data-testid={`aht-tab-${t.toLowerCase().replace(" ", "-")}`} disabled={disabled} onClick={() => setTab(t)}
              className={`relative whitespace-nowrap px-4 py-3 font-heading text-sm font-semibold transition-colors ${
                tab === t ? "text-thstrong" : disabled ? "text-thfaint" : "text-thmute hover:text-thbody"}`}>
              {t}
              {tab === t && <span className="absolute inset-x-2 bottom-0 h-[2px] rounded-full bg-thcyan" />}
            </button>
          );
        })}
      </nav>
      {hasData && tab !== "Upload" && (
        <p data-testid="aht-dataset-badge" className="mk-sub mb-4">{fmtNum(summary.total)} benchmark calls loaded</p>
      )}
      {!summary ? <Loading /> : (
        <>
          {tab === "Upload" && <UploadTab {...props} />}
          {tab === "Dashboard" && <DashboardTab {...props} />}
          {tab === "Date Analysis" && <DateTab {...props} />}
          {tab === "Trends" && <TrendsTab {...props} />}
          {tab === "Agents" && <AgentsTab {...props} />}
          {tab === "Benchmark" && <BenchmarkTab {...props} />}
          {tab === "Export" && <ExportTab {...props} />}
        </>
      )}
    </AppShell>
  );
}
